export default [
   "AMBOS", "DIURNO", "NOTURNO" 
];